import store from '../store';
import api from "../api";
import router from "../router";

function saveQueryParams(to, next) {
	if (to.query.mf || to.query.as || to.query.cr || to.query.y || to.query.rt) {
		localStorage.ffaUserRego = JSON.stringify({
			mf: to.query.mf ? to.query.mf : null,
			as: to.query.as ? to.query.as : null,
			cr: to.query.cr ? to.query.cr : null,
			y: to.query.y ? to.query.y : null,
			rt: to.query.rt ? to.query.rt : null
		});

		localStorage.regoInProgress = true;

		next({
			...to,
			query: {}
		});
	}
}

function saveRedirectUri(to, next) {
	if (to.query.redirect_uri) {
		localStorage.ffaRedirectUri = to.query.redirect_uri;

		if (to.query.client_id) {
			localStorage.ffaClientId = to.query.client_id;
			window.CognitoClientIdPlayfootball = localStorage.ffaClientId;
		}

		if (to.query.platform) {
			localStorage.ffaPlatform = to.query.platform;
		}
		next({
			...to,
			query: {}
		});
	}
}

function doRedirectUri(user) {
	const url = new URL(window.location.origin);
	url.pathname = '/oauth2/complete';
	url.searchParams.set('client_id', CognitoClientIdPlayfootball);
	url.searchParams.set('redirect_uri', localStorage.ffaRedirectUri);
	url.searchParams.set('id_token', user.idToken);

	localStorage.removeItem('ffaRedirectUri');
	localStorage.removeItem('ffaClientId');
	localStorage.removeItem('ffaPlatform');
	localStorage.removeItem('ffaUserRego');
	window.location.href = url.href;
}

function checkRegoOffers(user) {

  return new Promise((resolve, reject) => {
		if (localStorage.ffaUserRego) {
			store.dispatch('user/BANGEO_SAVE_USER').then(() => {
				if (user.onboardingcomplete !== 'Skipped' && !localStorage.ffaRedirectUri) {
					store.dispatch('onboarding/SKIP_PREFERENCES_SELECTION_REGO').then(() => {
						// console.log("Skipped.");
					});
				}
				// check if any available offers
				api.bangeo.getOffersByUser().then(result => {
					let offers = result.data.offers;
					if(offers.length > 0){
						router.push({name: 'offers'});
					} else {
            resolve();
          }
				});
			});
		} else {
      resolve();
    }
  });
}

function checkRedirectUri(user) {
  return new Promise ((resolve, reject) => {
		if (localStorage.ffaRedirectUri) {
			if (localStorage.ffaPlatform === CognitoPlatforms.PlayFootball) {
				if (user.onboardingcomplete !== 'Skipped') {
					store.dispatch('onboarding/SKIP_PREFERENCES_SELECTION_REGO');
				}
				api.bangeo.saveUser();
				doRedirectUri(user);
			} else {
        doRedirectUri(user);
			}
		} else {
        resolve();
		}
	});
}

function getUser() {
	const stateUser = store.state.user.user;

	return new Promise((resolve) => {
		if (stateUser) {
			if ((stateUser.exp * 1000) > Date.now()) {
				resolve(stateUser);
			}
		} else {
			store
				.dispatch('user/RETRIEVE_USER')
				.then(() => {
					resolve(store.state.user.user);
				})
				.catch(err => {
					resolve();
					// console.log('getUserCatch: ', err);
				});
		}
	});
}

export default function (to, from, next) {
	// scroll to top... simulate a new page load
	window.scrollTo(0,0);
	saveRedirectUri(to, next);
	saveQueryParams(to, next);

	store
		.dispatch('CHANGE_LOADING_STATE', true)
		.then(() => {
			getUser()
				.then(user => {
					if (user) {
            checkRegoOffers(user)
              .then(() => {
                checkRedirectUri(user).then(() => next())
              });
					} else {
						next();
					}
				});
		});
}
